import { c as _c } from "react/compiler-runtime";
import SchoolIcon from '@mui/icons-material/School';
import ProductMetadata, { Props as ProductMetadataProps } from '../ProductMetadata';
export interface Props extends Omit<ProductMetadataProps, 'icon' | 'children'> {
  children: string;
  accessibilityLabel: string;
}
const ProductMetadataCertification = t0 => {
  const $ = _c(14);
  let accessibilityLabel;
  let children;
  let otherProps;
  let overTitle;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      sx,
      accessibilityLabel,
      children,
      overTitle,
      shouldNotWrap: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = accessibilityLabel;
    $[2] = children;
    $[3] = otherProps;
    $[4] = overTitle;
    $[5] = sx;
    $[6] = t1;
  } else {
    accessibilityLabel = $[1];
    children = $[2];
    otherProps = $[3];
    overTitle = $[4];
    sx = $[5];
    t1 = $[6];
  }
  const shouldNotWrap = t1 === undefined ? true : t1;
  if (!children) {
    return null;
  }
  let t2;
  if ($[7] !== accessibilityLabel || $[8] !== children || $[9] !== otherProps || $[10] !== overTitle || $[11] !== shouldNotWrap || $[12] !== sx) {
    t2 = <ProductMetadata icon={SchoolIcon} accessibilityLabel={accessibilityLabel} shouldNotWrap={shouldNotWrap} sx={sx} overTitle={overTitle} {...otherProps}>{children}</ProductMetadata>;
    $[7] = accessibilityLabel;
    $[8] = children;
    $[9] = otherProps;
    $[10] = overTitle;
    $[11] = shouldNotWrap;
    $[12] = sx;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
export default ProductMetadataCertification;